export const getReviewsFormatted = (reviews) => {
  if (reviews) {
    return reviews.map((hit) => {
      return {
        quote: hit.translated_house_comment,
        stay: hit.contract_check_in_date,
        username: hit.client_shortened_full_name,
      }
    })
  }

  return []
}
